import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataTablesResponse } from '../models/datatables';
import { RenaultPopupDTO } from '../models/renault-popup-dto';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PopupService {

  private pathAPI = environment.urlAPI;
  private controller = 'RenaultPopup/';

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<RenaultPopupDTO> {
    return this.http.get<RenaultPopupDTO>(`${this.pathAPI}${this.controller}${id}`);
  }

  public getAll(): Observable<RenaultPopupDTO[]> {
    return this.http.get<RenaultPopupDTO[]>(`${this.pathAPI}${this.controller}GetAll/`);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(`${this.pathAPI}${this.controller}`, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(`${this.pathAPI}${this.controller}${id}`, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(`${this.pathAPI}${this.controller}ChangeStatus/${id}/${idStatus}`, null);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(`${this.pathAPI}${this.controller}GetDataTable/`, data);
  }

  public trackPopup(idPopup: string): Observable<any> {
    return this.http.get<any>(`${this.pathAPI}${this.controller}TrackPopup/${idPopup}`);
  }

  public getPollStatsExcel(id: string): Observable<Blob> {
    return this.http.get(`${this.pathAPI}${this.controller}GetPollStatsExcel/${id}`, { responseType: 'blob' });
  }
}

